import { gql } from '@apollo/client';

export const CREATE_OFFER_INTERACTION_MAIL = gql`
    mutation CreateOfferInteractionMail($offerInteractionMailInput: OfferInteractionMailInput!) {
        createOfferInteractionMail(offerInteractionMailInput: $offerInteractionMailInput)
    }
`;
